import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { notificationsAPI } from '../services/api';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import NotificationsIcon from '@mui/icons-material/Notifications';

const NotificationsPage = () => {
    const navigate = useNavigate();
    const [allNotifications, setAllNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAllNotifications = async () => {
            try {
                // Pass include_cleared=true to get everything
                const response = await notificationsAPI.getNotifications({ include_cleared: true });
                setAllNotifications(response.data.data.notifications);
                setLoading(false);
            } catch (err) {
                console.error("Failed to fetch all notifications", err);
                setError("Failed to load notifications. Please try again later.");
                setLoading(false);
            }
        };

        fetchAllNotifications();
    }, []);

    const handleNotificationClick = async (n) => {
        if (!n.is_read) {
            try {
                await notificationsAPI.markAsRead(n.id);
                setAllNotifications(prev => prev.map(item => item.id === n.id ? { ...item, is_read: true } : item));
            } catch (err) {
                console.error("Failed to mark as read", err);
            }
        }
        if (n.link) {
            navigate(n.link);
        }
    };

    if (loading) return <div className="p-20 text-center">Loading notifications...</div>;
    if (error) return <div className="p-20 text-center" style={{ color: 'red' }}>{error}</div>;

    return (
        <div className="card fade-in" style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div className="flex justify-between align-center mb-20 pb-10 border-b">
                <h1 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <NotificationsIcon color="primary" /> All Notifications
                </h1>
            </div>

            {allNotifications.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#64748b' }}>
                    No notifications to show.
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {allNotifications.map((n) => (
                        <div 
                            key={n.id} 
                            onClick={() => handleNotificationClick(n)}
                            style={{
                                padding: '15px',
                                border: '1px solid #e2e8f0',
                                borderRadius: '8px',
                                backgroundColor: n.is_read ? '#f8fafc' : '#ffffff',
                                borderLeft: n.is_read ? '1px solid #e2e8f0' : '4px solid #0d9488',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease'
                            }}
                            onMouseOver={(e) => e.currentTarget.style.transform = 'translateX(5px)'}
                            onMouseOut={(e) => e.currentTarget.style.transform = 'translateX(0)'}
                        >
                            <div>
                                <h3 style={{ margin: '0 0 5px 0', fontSize: '15px', color: '#0f172a' }}>{n.title}</h3>
                                <p style={{ margin: 0, fontSize: '13px', color: '#475569' }}>{n.message}</p>
                                <span style={{ fontSize: '11px', color: '#94a3b8', display: 'block', marginTop: '8px' }}>
                                    {new Date(n.created_at).toLocaleString()}
                                </span>
                            </div>
                            <ChevronRightIcon style={{ color: '#cbd5e1' }} />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default NotificationsPage;
